document.querySelectorAll('.product_feilds').forEach(function(productField) {
  const PACK_SIZES_main = productField.querySelector('#pack_sizes').textContent;
  let PACK_SIZES, PACK_RATIO, PACK_QTY;
// console.log(PACK_SIZES_main + "pack size main")
  if (PACK_SIZES_main.includes("=")) {
    const splitData = PACK_SIZES_main.split(';');
    // console.log(splitData.length +"splitData")
    // console.log(splitData[0]+"splitData 0")
    // console.log(splitData[1]+"splitData 1")
    if (splitData.length == 1){
      var firstPart = splitData[0].split('=')[0];
    var secondPart = splitData[0].split('=')[1] ;
      
    var firstPart_arr = firstPart.toLowerCase().replace(/\s/g, '').split(';');
      // console.log(firstPart + " firstpart");
    // console.log(secondPart + "secondpart");
    // console.log(firstPart_arr + "firstPart_arr");
    }else
    {var firstPart = splitData[0].split('=')[0] + ';' + splitData[1].split('=')[0];
    var secondPart = splitData[0].split('=')[1] + ';' + splitData[1].split('=')[1];
     
    var firstPart_arr = firstPart.toLowerCase().replace(/\s/g, '').split(';');
    // console.log(firstPart + " firstpart");
    // console.log(secondPart + "secondpart");
    // console.log(firstPart_arr + "firstPart_arr");
    }


    PACK_SIZES = secondPart;
  } else {
    PACK_SIZES = PACK_SIZES_main;
  }

  const product_fields_id = productField.dataset.id;
  const product_fields = document.querySelector('#product_fields' + product_fields_id);
  PACK_RATIO = productField.querySelector('#pack_ratio').textContent;
  PACK_QTY = productField.querySelector('#pack_qty').textContent;
  // console.log(PACK_SIZES + "pack size");
  //console.log(PACK_RATIO + "PACK_RATIO");
  //console.log(PACK_QTY + "PACK_QTY");

  // Return if any of them is empty
  if (PACK_SIZES === "" || PACK_RATIO === "" || PACK_QTY === "") {
    return;
  }

  // Extra sizes checking
  let custom_sizes_exist = true;
  const pack_sizes_arr = PACK_SIZES.split(';');

  // productField.querySelector('.productVariants-row input[type="radio"]:first-child').checked = true;

  const pack_ratio_arr = PACK_RATIO.split(';');
  let table_header = "";
  let table_wrapper = "";
  let table_body = "";
  let quntity_in_pack = "";
 // console.log(pack_ratio_arr);

  for (let i = 0; i < pack_sizes_arr.length; i++) {
    const size_arr = pack_sizes_arr[i].split(':');
    const ratio_arr = pack_ratio_arr[i] === undefined ? 1 : pack_ratio_arr[i].split(':');

    table_header = "";
    table_wrapper = "";
    table_body = "";
    quntity_in_pack = "";

    if (PACK_SIZES_main.includes("=")) {
      table_wrapper += '<div class="productVariants-size pack' + product_fields_id + firstPart_arr[i].toLowerCase() + '"> <div class="sizeVariants">';
    } else {
      table_wrapper += '<div class="productVariants-size pack' + product_fields_id + pack_sizes_arr[i].toLowerCase().replace(/ /g, '') + '"> <div class="sizeVariants">';
    }

    table_wrapper += '<table class="sizeVariants-table" border="1">';
    table_header += '<thead><tr class="sizeVariants-header normal-sizes">';
    table_header += '<td>' + "Size / Colour" + '</td>';

    for (let j = 0; j < size_arr.length; j++) {
      const size = size_arr[j];
      const size_without_num_arr = size.split('=');
      const size_without_num = size_without_num_arr[0];
      table_header += '<td>' + size_without_num + '</td>';
    }

    table_header += '</tr></thead>';
    table_wrapper += table_header;
    table_wrapper += '<tbody class="sizeVariants-body">';
    table_body += '<tr class="sizeVariants-item">';
    table_body += '<td>' + "Ratio" + '</td>';

    for (let j = 0; j < ratio_arr.length; j++) {
      const ratio = ratio_arr[j];
      quntity_in_pack += "+" + ratio;
      table_body += '<td>' + ratio + '</td>';
    }

    table_body += '</tr>';

    table_wrapper += table_body;
    table_wrapper += '</tbody></table>';
    table_wrapper += '</div></div>';
    
    quntity_in_pack = quntity_in_pack.replace(/\+/g, '');
    if (PACK_RATIO.includes(":")) {
    const numbers = quntity_in_pack.split('').map(numStr => parseInt(numStr));
    var total_quntity_in_pack = numbers.length > 0 ? numbers.reduce((acc, curr) => acc + curr) : 1;
    //console.log(quntity_in_pack, "quntity_in_pack")
    //console.log(numbers, "numbers")
    //console.log(total_quntity_in_pack, "total_quntity_in_pack")
    }else{
      //console.log("in")
      var total_quntity_in_pack = quntity_in_pack;
    }
    let html_quntity_in_pack;
    if (PACK_SIZES_main.includes("=")) {
      html_quntity_in_pack = '<span class="pack' + product_fields_id + firstPart_arr[i].toLowerCase() + '">' + total_quntity_in_pack + '</span>';
    } else {
      html_quntity_in_pack = '<span class="pack' + product_fields_id + pack_sizes_arr[i].toLowerCase().replace(/ /g, '') + '">' + total_quntity_in_pack + '</span>';
    }
//console.log(html_quntity_in_pack, "html_quntity_in_pack")
    productField.querySelector('.totalquntityinpack').insertAdjacentHTML('beforeend', html_quntity_in_pack);
    productField.querySelector('.productVariants-row').insertAdjacentHTML('beforeend', table_wrapper);
  }
});
document.querySelectorAll('.productVariants-size').forEach(function(element) {
  if (element.nextElementSibling === null) {
    element.classList.add('showed');
  }
});

 var gridunitprice = function(){
$('.product-eachh').each(function() {
  var priceMatch = $(this).find(".total-price .money").text().match(/\d+\.\d+/);
var quantityMatch = $(this).find('.number-of-pack-all').find('.showed').text();

if (quantityMatch === "") {
  quantityMatch = $(this).find('.number-of-pack-all').children().first().text();
  if (quantityMatch === "") {
   quantityMatch = $(this).find('.number-of-pack-all').text();
  }
  // if (quantityMatch === "") {
  //   quantityMatch = 1;
  //   $(this).find('.totalquntityinpack').text(quantityMatch) ;
  // }
}
    // console.log(priceMatch +"_____"+ quantityMatch);
  if (priceMatch && quantityMatch) {
    var price = parseFloat(priceMatch); // Extract the price from the string
    var quantity = parseInt(quantityMatch); // Extract the quantity from the string

    // console.log(price +"__paresed___"+ quantity);
    var pack = price / quantity;

       let currency=document.querySelector('.money')
        // Extract the first letter of the string
        const firstLetter = currency?.innerText?.trim().charAt(0);
    let unit=firstLetter?firstLetter:"£"
    let money=document.querySelectorAll('.product-block .unit_price')
    
       if(money?.length>0){
    $(this).find(".unit_price").text(pack.toFixed(2));
         
       }
    else{
    $(this).find(".unit_price").text(unit + pack.toFixed(2));
      
    }
     //console.log('unitp');
   // console.log(pack);
  } else {
   // console.log("Invalid format: " + priceMatch +"_____"+ quantityMatch);
  }
});
}
 if($('.variant-input__hh-size').is(':checked')) {
    // get the data-packid attribute of the checked input
    var packs = $('.variant-input__hh-size:checked').data('pack-id');
   //console.log(packs)
    $(packs).show();
    $(packs).addClass("showed");
    $(packs).siblings().hide();
    $(packs).siblings().removeClass("showed");
   
}
  $('.variant-input__hh-size').change(function() {

    // get the data-packid attribute of the selected radio input
 var variant_price = $(this).nextAll('label').first().find('.variant-price-grid-hh .money').text();
  var price_main_hmh = $(this).closest(".grid-product__meta").find(".grid-product__price .money .money");
  
  // Update the displayed price with the extracted variant price
  price_main_hmh.text(variant_price);
    var packed = $(this).data('pack-id');
    $(packed).show();
    $(packed).addClass("showed");
    $(packed).siblings().hide();
    $(packed).siblings().removeClass("showed");
     
gridunitprice();
  });  


 $(".number-of-pack-all").ready(function() { 
    gridunitprice();
  }) 
 $('.variant-input__hh-size').on('change', function() {
   
   var variant_price = $(this).nextAll('label').first().find('.variant-price-grid-hh .money').text();
  var price_main_hmh = $(this).closest(".grid-product__meta").find(".grid-product__price .money");
   
  
//   // Update the displayed price with the extracted variant price
  price_main_hmh.text(variant_price);
 gridunitprice();
 });
document.addEventListener('DOMContentLoaded', function () {
    let currency = document.querySelectorAll('.list li');
    //console.log(currency); // Logs the NodeList of <li> elements
    
    // Loop through each <li> element and attach an event listener
    currency.forEach(function(productField) {
        productField.addEventListener('click', function () {
           // console.log(productField.getAttribute("data-currency-symbol"));
          setTimeout(() => {
            gridunitprice();
          }, 2000);

 // Logs the innerHTML of the clicked <li> element
        });
    });
});
